import styled from 'styled-components';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import { Divider } from '@awaze/design-system.components.divider';
export const StyledFooter = styled.footer `
  background-color: ${({ theme }) => theme.ColorThemeDark300};
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
`;
export const StyledFooterAnchor = styled.a `
  color: ${({ theme }) => theme.ColorWhiteOpacity100};
  font-size: ${({ theme }) => pxToRems(theme.FontTextText200FontSize)};
  margin-bottom: 8px;
  text-decoration: none;
`;
export const StyledDivider = styled(Divider) `
  display: none;
  @media (min-width: ${breakpoints[0]}px) {
    display: block;
  }
`;
//# sourceMappingURL=footer.styles.js.map